const Constants = {
    ALL_DOMAIN_NAME: 'All',
    ALL_DOMAIN_ID: 'aaaabbbb-aaaa-bbbb-aaaa-bbbbaaaabbbb',
    RICH_TEXT_CHAR_LIMIT: 15000000,
    NORMAL_TEXT_CHAR_LIMIT: 1000,
} as const;

export default Constants;
